/* ===========================================================================
   wwc-product.js

   TWEE MODULES VERWIJDERD (16 aug 2026), samen ongeveer 6 KB:

   1. Info Hub — bediende [data-wwc-product-info-hub]. Die sectie staat in
      NUL van de 21 producttemplates aan (13 uitgeschakeld, 8 zonder). De code
      zocht dus op elke pagina naar iets dat nergens bestond.

   2. Videostarters — bediende de markup uit wwc-product-video-under-gallery.
      De enige render daarvan staat binnen een commentaarblok in
      product-template.liquid, dus die markup wordt nooit uitgevoerd.

   Wat WEL blijft: de Afmeting-module (wwc-size-guide). Die is de reden dat dit
   bestand op alle pagina's laadt - de quick view op collectiepagina's plakt
   productmarkup in de pagina en heeft hem nodig.
   =========================================================================== */

(function () {
      if (window.WWCProductVideoLightboxInit) return;
      window.WWCProductVideoLightboxInit = true;

      document.addEventListener('click', function(event) {
        /* Dit bestand draait sinds de quick-view-fix op ELKE pagina. Een
           document-breed keydown/click kan een target hebben dat geen Element
           is (document zelf, een tekstknoop) en dan bestaat closest niet. */
        if (!event.target || typeof event.target.closest !== 'function') return;
        var openBtn = event.target.closest('[data-wwc-video-open]');
        var closeBtn = event.target.closest('[data-wwc-video-close]');

        if (openBtn) {
          var card = openBtn.closest('[data-wwc-video-card]');
          if (!card) return;

          var lightbox = card.querySelector('[data-wwc-video-lightbox]');
          if (!lightbox) return;

          var video = lightbox.querySelector('video');

          lightbox.hidden = false;
          document.documentElement.classList.add('wwc-video-open');

          if (video) {
            video.currentTime = 0;
            video.play().catch(function(){});
          }
        }

        if (closeBtn) {
          var lightbox = closeBtn.closest('[data-wwc-video-lightbox]');
          if (!lightbox) return;

          var video = lightbox.querySelector('video');

          if (video) video.pause();
          lightbox.hidden = true;
          document.documentElement.classList.remove('wwc-video-open');
        }
      });

      document.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape') return;

        var lightbox = document.querySelector('[data-wwc-video-lightbox]:not([hidden])');
        if (!lightbox) return;

        var video = lightbox.querySelector('video');
        if (video) video.pause();

        lightbox.hidden = true;
        document.documentElement.classList.remove('wwc-video-open');
      });
    })();

/* ==================================================
   WWC Product - Size Guide
   CSS: assets/custom.css
================================================== */

(function () {
  function clean(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function getCopy(lang) {
  /* LET OP - de `tip` MOET op mobiel op EEN regel passen.
     Op 375px blijft er naast de badge ("Meest gekozen", 120px) en de tussen-
     ruimte 224px over voor de tekst. Bij 12px/500 met letter-spacing 0.35px
     is dat ongeveer 37 tekens; de letter-spacing telt echt mee (13px over een
     regel van 38 tekens) dus reken niet met tekens alleen, meet.

     Breekt de tip af, dan wordt de kaart 15px hoger en duwt hij de rest van
     de pagina naar beneden - precies de klacht die deze teksten kortte. De
     standing-tips waren met 65 tekens (NL) tot 86 (FR) de langste van de
     tabel; EN, DE en FR duwden daarbij ook nog naar 60 cm, terwijl dat bij NL
     bewust was weggehaald (zie de opmerking bij standing 40 hieronder).

     De beschikbare ruimte hangt af van de BADGE, en die verschilt per maat:
     "Meest gekozen" is 120px, "Onze aanrader" 102px, "Statement" 77px. Dus
     224px bij 40/80, 242px bij 60/100 en 267px bij 120. Meet tegen de maat
     waar de tekst bij hoort, niet tegen de smalste.

     Gemeten marge na deze ronde (375px, Helvetica = het ruimste geval):
       standing 40: NL 12.7  EN 35.3  DE 8.3  FR 65.9
       standing 60: NL 29.3  EN 33.3  DE 17.6 FR 33.7
       wand 80:     NL 31    EN 33    DE 23   FR 54
       wand 100:    NL 25    EN 67    DE 73   FR 84
       wand 120:    NL 43    EN 47    DE 44   FR 74
     Duits 40 is met 8.3px de krapste; wie daar een woord verlengt moet
     opnieuw meten. Alles hierboven paste vóór deze ronde op GEEN van de
     maten op een regel - alle vijftien tips braken af op mobiel. */
    const copy = {
      nl: {
        standing: {
          40: {
            /* BADGE OP 40 CM, want dat is de feitelijke winnaar: 665 stuks
               tegen 544 voor 60 cm (365 dagen). De badge stond op 60 en was
               daarmee een onjuiste claim - en sociale bewijsuitspraken moeten
               waar zijn.

               Geen duw naar 60 cm meer in deze tip. Wie 40 kiest heeft een
               goede reden; de badge op 60 cm doet het sturende werk al. Twee
               keer duwen maakte twijfelen makkelijker dan kiezen. */
            text: 'Past overal',
            badge: '⭐ Meest gekozen',
            tip: 'Bureau, boekenplank of vensterbank.'
          },
          60: {
            text: 'Direct in het oog',
            badge: 'Onze aanrader',
            tip: 'Sterke cadeaukeuze, niet te groot.'
          }
        },
        wall: {
          80: {
            text: 'Rustig en compact',
            badge: '⭐ Meest gekozen',
            tip: 'Smallere muur, hal of slaapkamer.'
          },
          100: {
            text: 'De veilige keuze',
            badge: 'Onze aanrader',
            tip: 'Groot genoeg, zonder te overheersen.'
          },
          120: {
            text: 'Echte blikvanger',
            badge: 'Statement',
            tip: 'Boven een bank, dressoir of lege wand.'
          }
        }
      },
      en: {
        standing: {
          40: {
            text: 'Compact and subtle',
            badge: '⭐ Most chosen',
            tip: 'Great on a desk, shelf or cabinet.'
          },
          60: {
            text: 'More impact at home',
            badge: 'Our pick',
            tip: 'A strong gift choice, not too large.'
          }
        },
        wall: {
          80: {
            text: 'Calm and compact',
            badge: '⭐ Most chosen',
            tip: 'Smaller wall, hallway or bedroom.'
          },
          100: {
            text: 'The safe choice',
            badge: 'Our pick',
            tip: 'Stands out without taking over.'
          },
          120: {
            text: 'A real eye-catcher',
            badge: 'Statement',
            tip: 'Above a sofa, sideboard or empty wall.'
          }
        }
      },
      de: {
        standing: {
          40: {
            text: 'Kompakt und dezent',
            badge: '⭐ Am beliebtesten',
            tip: 'Auf Schreibtisch, Regal oder Schrank.'
          },
          60: {
            text: 'Mehr Wirkung im Zuhause',
            badge: 'Unsere Empfehlung',
            tip: 'Starke Geschenkidee, nicht zu groß.'
          }
        },
        wall: {
          80: {
            text: 'Ruhig und kompakt',
            badge: '⭐ Am beliebtesten',
            tip: 'Schmale Wand, Flur, Schlafzimmer.'
          },
          100: {
            text: 'Die sichere Wahl',
            badge: 'Unsere Empfehlung',
            tip: 'Fällt auf, ohne zu dominieren.'
          },
          120: {
            text: 'Ein echter Blickfang',
            badge: 'Statement',
            tip: 'Über Sofa, Sideboard oder leere Wand.'
          }
        }
      },
      fr: {
        standing: {
          40: {
            text: 'Compact et discret',
            badge: '⭐ Le plus choisi',
            tip: 'Bureau, étagère ou meuble.'
          },
          60: {
            text: 'Plus de présence chez toi',
            badge: 'Notre choix',
            tip: 'Excellent cadeau, pas trop grand.'
          }
        },
        wall: {
          80: {
            text: 'Discret et compact',
            badge: '⭐ Le plus choisi',
            tip: 'Petit mur, couloir ou chambre.'
          },
          100: {
            text: 'Le choix sûr',
            badge: 'Notre choix',
            tip: 'Assez grand, sans dominer.'
          },
          120: {
            text: 'Un vrai point fort',
            badge: 'Statement',
            tip: 'Canapé, buffet ou grand mur vide.'
          }
        }
      }
    };

    return copy[lang] || copy.nl;
  }

  function getData(kind, size, lang) {
    const s = clean(size);
    const copy = getCopy(lang);
    const base = copy[kind] && copy[kind][s];

    if (!base) return null;

    const widths = {
      standing: { 40: 55, 60: 75 },
      wall: { 80: 65, 100: 82, 120: 100 }
    };

    const upsells = {
      standing: { 40: false, 60: true },
      wall: { 80: false, 100: false, 120: false }
    };

    return {
      text: base.text,
      badge: base.badge,
      label: s + ' cm',
      width: widths[kind][s],
      tip: base.tip,
      upsell: upsells[kind][s]
    };
  }

  function updateGuide(guide) {
    const wrap = guide.closest('.variant-wrapper');
    if (!wrap) return;

    const checked =
      wrap.querySelector('input[name="Afmeting"]:checked') ||
      wrap.querySelector('input[name="Size"]:checked') ||
      wrap.querySelector('input[name="Größe"]:checked') ||
      wrap.querySelector('input[name="Taille"]:checked');

    if (!checked) return;

    const lang = guide.dataset.lang || document.documentElement.lang.slice(0, 2) || 'nl';
    const data = getData(guide.dataset.kind, checked.value, lang);

    if (!data) return;

    const text = guide.querySelector('[data-text]');
    const badge = guide.querySelector('[data-badge]');
    const label = guide.querySelector('[data-label]');
    const tip = guide.querySelector('[data-tip]');
    const fill = guide.querySelector('[data-fill]');
    const upsell = guide.querySelector('[data-upsell]');

    if (text) text.innerText = data.text;

    if (badge) {
      badge.innerText = data.badge || '';
      badge.hidden = !data.badge;
    }

    if (label) label.innerText = data.label;
    if (tip) tip.innerText = data.tip;
    /* Evenredig aan de werkelijke maat, niet aan een handmatig percentage.
       Zolang de balk geen schaal had viel dat niemand op; met een eindpunt
       ernaast zou een 40 cm-balk op 55% een bereik suggereren dat niet klopt.
       Valt terug op de tabel als data-max-size ontbreekt. */
    if (fill) {
      var maxSize = parseFloat(guide.getAttribute('data-max-size') || '');
      var curSize = parseFloat(checked.value);
      var pct = data.width;
      if (maxSize > 0 && curSize > 0) {
        pct = Math.round((curSize / maxSize) * 100);
      }
      fill.style.width = pct + '%';
    }
    if (upsell) upsell.hidden = !data.upsell;
  }

  function initSizeGuides() {
    const guides = document.querySelectorAll('[data-wwc-size-guide]');
    if (!guides.length) return;

    guides.forEach(function (guide) {
      if (guide.dataset.inited === '1') return;
      guide.dataset.inited = '1';

      updateGuide(guide);

      const wrap = guide.closest('.variant-wrapper');
      if (!wrap) return;

      wrap.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          updateGuide(guide);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuides);
  } else {
    initSizeGuides();
  }

  document.addEventListener('shopify:section:load', initSizeGuides);
})();


/* ==================================================
   WWC Product Video Under Gallery v2.1
   File: assets/wwc-product-video.js
================================================== */

(function () {
  if (window.WWCProductVideoInit) return;
  window.WWCProductVideoInit = true;

  var activeLightbox = null;
  var activeTrigger = null;
  var scrollY = 0;

  function getLightbox(card) {
    if (!card) return null;

    if (card.__wwcVideoLightbox) {
      return card.__wwcVideoLightbox;
    }

    var lightbox = card.querySelector('[data-wwc-video-lightbox]');

    if (lightbox) {
      card.__wwcVideoLightbox = lightbox;
    }

    return lightbox;
  }

  function getFocusable(container) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll(
        'button, [href], video[controls], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function setRatioFromVideo(lightbox, video) {
    if (!lightbox || !video || !video.videoWidth || !video.videoHeight) return;

    var ratio = video.videoWidth / video.videoHeight;

    if (ratio > 1.25) {
      lightbox.setAttribute('data-wwc-video-ratio', '16-9');
    } else if (ratio < 0.85) {
      lightbox.setAttribute('data-wwc-video-ratio', '9-16');
    } else {
      lightbox.setAttribute('data-wwc-video-ratio', '1-1');
    }
  }

  function lockPage() {
    scrollY = window.scrollY || window.pageYOffset || 0;

    document.documentElement.classList.add('wwc-video-open');
    document.body.classList.add('wwc-video-open');
    document.body.style.top = '-' + scrollY + 'px';
  }

  function unlockPage() {
    document.documentElement.classList.remove('wwc-video-open');
    document.body.classList.remove('wwc-video-open');
    document.body.style.top = '';

    window.scrollTo(0, scrollY || 0);
  }

  function moveLightboxToBody(lightbox) {
    if (!lightbox || lightbox.parentNode === document.body) return;
    document.body.appendChild(lightbox);
  }

  function openVideo(card, trigger) {
    var lightbox = getLightbox(card);
    if (!lightbox) return;

    var video = lightbox.querySelector('[data-wwc-video-player]');
    var source = video ? video.querySelector('source') : null;
    var dialog = lightbox.querySelector('.wwc-product-video-modal__dialog');

    activeLightbox = lightbox;
    activeTrigger = trigger || null;

    moveLightboxToBody(lightbox);

    if (source && !source.getAttribute('src')) {
      var src = source.getAttribute('data-src');

      if (src) {
        source.setAttribute('src', src);
      }
    }

    if (video) {
      video.preload = 'metadata';

      if (!video.__wwcMetadataListenerAdded) {
        video.__wwcMetadataListenerAdded = true;

        video.addEventListener('loadedmetadata', function () {
          setRatioFromVideo(lightbox, video);
        });
      }

      video.load();
    }

    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');

    lockPage();

    window.setTimeout(function () {
      if (dialog) {
        dialog.focus({ preventScroll: true });
      }

      if (video) {
        video.currentTime = 0;

        var playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    }, 80);
  }

  function closeVideo(lightbox) {
    if (!lightbox) return;

    var video = lightbox.querySelector('[data-wwc-video-player]');

    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');

    unlockPage();

    if (activeTrigger && typeof activeTrigger.focus === 'function') {
      activeTrigger.focus({ preventScroll: true });
    }

    activeLightbox = null;
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var openBtn = event.target.closest('[data-wwc-video-open]');
    var closeBtn = event.target.closest('[data-wwc-video-close]');

    if (openBtn) {
      event.preventDefault();

      var card = openBtn.closest('[data-wwc-video-card]');
      openVideo(card, openBtn);
      return;
    }

    if (closeBtn) {
      event.preventDefault();

      var lightbox = closeBtn.closest('[data-wwc-video-lightbox]');
      closeVideo(lightbox);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!activeLightbox || activeLightbox.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeVideo(activeLightbox);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusable(activeLightbox);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

/* ==================================================
   WWC Product - Related by City Bubbles
   CSS: assets/custom.css
================================================== */

(function () {
  const roots = document.querySelectorAll('[data-wwc-city-bubbles]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.inited === '1') return;
    root.dataset.inited = '1';

    const configEl = root.querySelector('[data-wwc-city-bubbles-config]');
    if (!configEl) return;

    let cfg = {};

    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (error) {
      console.warn('WWC City Bubbles config error:', error);
      return;
    }

    const sliderEl = root.querySelector('.wwc-rel-slider');
    const wrap = root.querySelector('.wwc-rel-container');

    if (!sliderEl || !wrap) return;

    const rootUrl = normalizeRootUrl(cfg.rootUrl || '/');
    const product = cfg.product || {};
    const productTags = Array.isArray(product.tags) ? product.tags : [];
    const prodTitle = String(product.title || '').toLowerCase();
    const prodTags = productTags.map(function (x) {
      return String(x || '').toLowerCase();
    });

    const MATERIALS = ['Beuken', 'Eiken', 'Noten', 'Bamboe', 'Palissander', 'Zwart', 'Zwart Glanzend', 'Wit Glanzend', 'Goud Metallic'];
    const MATERIAL_DISPLAY = cfg.materialDisplay || {};
    const LABELS = cfg.labels || {};
    const INFO_TEXT = cfg.info || {};
    const BADGE_TEXT = cfg.badges || {};
    const EXTRA_CHIP = cfg.extraChips || {};
    const LABEL_MATERIALS = cfg.labelMaterials || 'kleuren';

    const ORDER = [
      'klok-halfrond',
      'klok-rond',
      'standing-skyline',
      'skyline-wand',
      'serveer-rect',
      'serveer-rond',
      'onderzetters',
      'telefoonhouder',
      'desk-organizer',
      'magneet',
      'citymap',
      'provincie',
      'landkaart',
      'wereldkaart',
      'merch'
    ];

    let swiper = null;
    let rawProducts = null;
    let buckets = null;

    const initialSlideSetting = cfg.startAtIndex || 1;
    const parsedInitial = parseInt(initialSlideSetting, 10);
    const initialSlideIndex = !Number.isNaN(parsedInitial) && parsedInitial > 1
      ? parsedInitial - 1
      : 0;

    function normalizeRootUrl(value) {
      let url = String(value || '/').trim();

      if (!url) return '/';
      if (url.charAt(0) !== '/') url = '/' + url;
      if (url.charAt(url.length - 1) !== '/') url += '/';

      return url;
    }

    function makeLocalizedUrl(path) {
      const cleanPath = String(path || '').replace(/^\/+/, '');
      return rootUrl + cleanPath;
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function detectCurrentMaterial() {
      if (/serveerplank|borrelplank/.test(prodTitle)) return 'Beuken';
      if (prodTags.some(function (t) { return t.indexOf('zwart glanzend') > -1; }) || /zwart glanzend/.test(prodTitle)) return 'Zwart Glanzend';
      if (prodTags.some(function (t) { return t.indexOf('wit glanzend') > -1; }) || /wit glanzend/.test(prodTitle)) return 'Wit Glanzend';
      if (prodTags.some(function (t) { return t.indexOf('goud') > -1 && t.indexOf('metal') > -1; }) || /goud metallic/.test(prodTitle)) return 'Goud Metallic';
      if (prodTags.some(function (t) { return t.indexOf('palissander') > -1; }) || /palissander/.test(prodTitle)) return 'Palissander';
      if (prodTags.some(function (t) { return t.indexOf('bamboe') > -1; }) || /bamboe/.test(prodTitle)) return 'Bamboe';
      if (prodTags.some(function (t) { return t.indexOf('noten') > -1 || t.indexOf('walnoot') > -1 || t.indexOf('walnut') > -1; }) || /noten|walnoot|walnut/.test(prodTitle)) return 'Noten';
      if (prodTags.some(function (t) { return t.indexOf('eiken') > -1; }) || /eiken|oak/.test(prodTitle)) return 'Eiken';
      if (/black/.test(prodTitle) || prodTags.some(function (t) { return t === 'black' || (t.indexOf('zwart') > -1 && t.indexOf('glanzend') === -1); })) return 'Zwart';

      return 'Eiken';
    }

    let activeMaterial = detectCurrentMaterial();

    const cityTag = (function () {
      for (let i = 0; i < productTags.length; i += 1) {
        const tag = String(productTags[i] || '');
        if (tag.slice(0, 5).toLowerCase() === 'stad_') return tag.toLowerCase();
      }

      return '';
    })();

    if (!cityTag) {
      sliderEl.setAttribute('aria-busy', 'false');
      return;
    }

    const collectionHandle = 'skyline-' + cityTag.replace(/^stad_/, '').replace(/_/g, '-');

    function detectMaterialLabel(productItem) {
      const blob = ((productItem.tags || []).join(',') + ',' + (productItem.title || '')).toLowerCase();

      if (/beuken|beech/.test(blob)) return 'Beuken';
      if (/eiken|oak/.test(blob)) return 'Eiken';
      if (/noten|walnoot|walnut/.test(blob)) return 'Noten';
      if (/bamboe|bamboo/.test(blob)) return 'Bamboe';
      if (/palissander/.test(blob)) return 'Palissander';
      if (/zwart glanzend/.test(blob)) return 'Zwart Glanzend';
      if (/wit glanzend/.test(blob)) return 'Wit Glanzend';
      if (/goud metallic/.test(blob)) return 'Goud Metallic';
      if (/black|zwart(?!\s*glanzend)/.test(blob)) return 'Zwart';

      return null;
    }

    function typeKey(productItem) {
      const title = (productItem.title || '').toLowerCase();
      const productType = (productItem.product_type || '').toLowerCase();

      if (title.indexOf('shape') > -1) return 'skip-shape';
      if (title.indexOf('borrelplank') > -1) return 'borrelplank';

      if ((productType === 'klok' || title.indexOf('klok') > -1) && title.indexOf('rond') > -1) return 'klok-rond';
      if (productType === 'klok' || title.indexOf('klok') > -1) return 'klok-halfrond';
      if (title.indexOf('standing') > -1) return 'standing-skyline';
      if (title.indexOf('wand') > -1 && title.indexOf('shape') === -1) return 'skyline-wand';
      if (title.indexOf('serveerplank') > -1 && title.indexOf('rond') > -1) return 'serveer-rond';
      if (title.indexOf('serveerplank') > -1 && title.indexOf('rond') === -1) return 'serveer-rect';
      if (productType === 'onderzetters' || title.indexOf('onderzetter') > -1) return 'onderzetters';
      if (title.indexOf('telefoonhouder') > -1) return 'telefoonhouder';
      if (productType === 'desk organizer' || title.indexOf('desk organizer') > -1) return 'desk-organizer';
      if (title.indexOf('magneet') > -1) return 'magneet';
      if (productType === 'citymap' || title.indexOf('citymap') > -1) return 'citymap';
      if (productType === 'provincie') return 'provincie';
      if (productType === 'landkaart') return 'landkaart';
      if (productType === 'wereldkaart') return 'wereldkaart';
      if (title.indexOf('rompertje') > -1 || title.indexOf('baby') > -1) return 'skip-baby';
      if (title.indexOf('hoodie') > -1) return 'merch';

      if ((productItem.tags || []).some(function (tag) {
        return String(tag).toLowerCase() === 'woodwidemerch';
      })) return 'merch';

      return 'skyline-wand';
    }

    function productHasCity(productItem) {
      return (productItem.tags || []).some(function (tag) {
        return String(tag || '').toLowerCase() === cityTag;
      });
    }

    function bestImage(productItem) {
      return productItem.images && productItem.images[0] ? productItem.images[0].src : '';
    }

    function findVariantForLabel(productItem, label) {
      if (!productItem || !Array.isArray(productItem.variants)) return null;

      const low = String(label || '').toLowerCase();
      const synonyms = {
        eiken: ['eiken', 'oak'],
        beuken: ['beuken', 'beech'],
        noten: ['noten', 'walnoot', 'walnut'],
        bamboe: ['bamboe', 'bamboo'],
        palissander: ['palissander'],
        'zwart glanzend': ['zwart glanzend'],
        'wit glanzend': ['wit glanzend'],
        'goud metallic': ['goud metallic'],
        zwart: ['black', 'zwart ']
      }[low] || [low];

      let id = null;

      productItem.variants.some(function (variant) {
        const blob = [variant.title, variant.option1, variant.option2, variant.option3].join(' ').toLowerCase();

        return synonyms.some(function (synonym) {
          if (blob.indexOf(synonym) > -1) {
            id = variant.id;
            return true;
          }

          return false;
        });
      });

      return id;
    }

    function productUrl(productItem, label) {
      if (!productItem) return '#';

      const base = makeLocalizedUrl('products/' + productItem.handle);

      if (!Array.isArray(productItem.variants) || !productItem.variants.length) {
        return base;
      }

      let variantId = label ? findVariantForLabel(productItem, label) : null;

      if (!variantId) {
        const firstAvailable = productItem.variants.find(function (variant) {
          return variant.available;
        });

        if (firstAvailable) variantId = firstAvailable.id;
      }

      return variantId ? base + '?variant=' + variantId : base;
    }

    function extractSizesFromVariants(productItem) {
      const output = [];

      if (!productItem || !Array.isArray(productItem.variants)) return output;

      productItem.variants.forEach(function (variant) {
        const blob = [variant.title, variant.option1, variant.option2, variant.option3].join(' ').toLowerCase();
        const matches = blob.match(/\b\d{1,3}(?:[.,]\d{1,2})?(?:x\d{1,3}(?:[.,]\d{1,2})?)?cm\b/g);

        if (matches) {
          matches.forEach(function (match) {
            output.push(match);
          });
        }
      });

      return output;
    }

    function formatSizeToken(raw) {
      if (!raw) return '';

      let value = String(raw).trim();

      value = value.replace(/\s*/g, '');
      value = value.replace(/cm$/i, ' cm');

      return '(' + value + ')';
    }

    function collectSizes(group) {
      const output = [];
      const seen = {};

      function pushFrom(productItem) {
        extractSizesFromVariants(productItem).forEach(function (size) {
          const value = size.toLowerCase();

          if (seen[value]) return;

          seen[value] = 1;
          output.push(value);
        });
      }

      if (group.byMat && group.byMat.Eiken) pushFrom(group.byMat.Eiken);
      if (!output.length && group.byMat && group.byMat[activeMaterial]) pushFrom(group.byMat[activeMaterial]);
      if (!output.length) pushFrom(group.any || null);

      return output.map(formatSizeToken);
    }

    function collectMaterials(group) {
      const map = {};

      if (!group.byMat) return map;

      Object.keys(group.byMat).forEach(function (label) {
        map[label] = productUrl(group.byMat[label], label);
      });

      return map;
    }

    function renderSwatch(label, url) {
      const displayLabel = MATERIAL_DISPLAY[label] || label;

      const color = {
        Eiken: '#C8A165',
        Beuken: '#E6D2B5',
        Noten: '#6B4F3A',
        Bamboe: '#D6BE8B',
        Zwart: '#000000',
        Palissander: '#7A2F1B',
        'Wit Glanzend': '#FFFFFF',
        'Zwart Glanzend': '#000000',
        'Goud Metallic': '#C9A646'
      }[label] || '#ddd';

      const shine = label === 'Zwart Glanzend'
        ? ';background-image:linear-gradient(135deg, rgba(255,255,255,.18) 0%, rgba(255,255,255,0) 40%)'
        : '';

      return '<a class="wwc-rel-swatch" href="' + escapeHtml(url) + '" data-tip="' + escapeHtml(displayLabel) + '" title="' + escapeHtml(displayLabel) + '" style="background:' + color + shine + '"></a>';
    }

    function buildBuckets(list) {
      const cityProducts = list.filter(productHasCity);
      const bucketMap = {};

      ORDER.forEach(function (key) {
        bucketMap[key] = { key: key, byMat: {}, any: null };
      });

      cityProducts.forEach(function (productItem) {
        const key = typeKey(productItem);

        if (!bucketMap[key]) return;

        let material = detectMaterialLabel(productItem);

        if (material && MATERIALS.indexOf(material) === -1) material = null;
        if (material && !bucketMap[key].byMat[material]) bucketMap[key].byMat[material] = productItem;
        if (!bucketMap[key].any) bucketMap[key].any = productItem;
      });

      return bucketMap;
    }

    function buildGroupsForMaterial(material) {
      if (!buckets) return [];

      const groups = [];

      ORDER.forEach(function (key) {
        const group = buckets[key];

        if (!group) return;

        let productItem = null;

        if (group.byMat[material]) productItem = group.byMat[material];
        else if (group.byMat.Eiken) productItem = group.byMat.Eiken;
        else if (group.any) productItem = group.any;

        if (!productItem) return;

        groups.push({
          key: key,
          product: productItem,
          byMat: group.byMat,
          any: group.any
        });
      });

      return groups;
    }

    function wireTooltips() {
      const badges = root.querySelectorAll('.wwc-rel-badge--materials');

      badges.forEach(function (badge) {
        badge.addEventListener('click', function (event) {
          event.stopPropagation();

          badges.forEach(function (other) {
            if (other !== badge) other.classList.remove('is-open');
          });

          badge.classList.toggle('is-open');
        });
      });

      document.addEventListener('click', function () {
        badges.forEach(function (badge) {
          badge.classList.remove('is-open');
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          badges.forEach(function (badge) {
            badge.classList.remove('is-open');
          });
        }
      });
    }

    function wireActive() {
      const items = root.querySelectorAll('.wwc-rel-item');
      if (!items.length) return;

      const locPath = window.location.pathname || '';
      const locPathNoSlash = locPath.replace(/\/+$/, '');
      const locFull = locPath + window.location.search;

      let activeSet = false;

      items.forEach(function (item, index) {
        const link = item.querySelector('.wwc-rel-link');
        if (!link) return;

        let href = link.getAttribute('href') || '';

        if (href.indexOf('http') === 0) {
          href = href.replace(window.location.origin, '');
        }

        const hrefNoHash = href.split('#')[0];
        const hrefPath = hrefNoHash;
        const hrefNoQuery = hrefNoHash.split('?')[0].replace(/\/+$/, '');

        if (!activeSet) {
          const matches =
            hrefNoQuery === locPathNoSlash ||
            hrefPath === locPath ||
            hrefPath === locFull ||
            hrefPath.indexOf(locPath + '?') === 0;

          if (matches) {
            item.classList.add('is-active');

            if (swiper) swiper.slideTo(index, 0);

            activeSet = true;
          }
        }
      });

      if (!activeSet) {
        const fallbackIndex = Math.min(initialSlideIndex, items.length - 1);
        if (items[fallbackIndex]) items[fallbackIndex].classList.add('is-active');
      }

      items.forEach(function (item) {
        item.addEventListener('click', function () {
          root.querySelectorAll('.wwc-rel-item.is-active').forEach(function (activeItem) {
            activeItem.classList.remove('is-active');
          });

          item.classList.add('is-active');
        });
      });
    }

    function enhance(groups) {
      const showSwatches = !!cfg.showSwatches;
      const showInfo = !!cfg.showInfo;
      const lazyValue = cfg.lazy ? 'lazy' : 'eager';

      let html = '';

      groups.forEach(function (group, index) {
        const productItem = group.product;
        const label = LABELS[group.key] || group.key;
        const imageSrc = bestImage(productItem);
        const url = productUrl(productItem, activeMaterial);
        const sizes = collectSizes(group);
        const materialMap = collectMaterials(group);
        const materials = Object.keys(materialMap);
        const materialCount = materials.length;

        let extra = String(EXTRA_CHIP[group.key] || '').trim();

        if (extra === '-' || extra === '—') extra = '';

        html += '<div class="wwc-rel-item swiper-slide" data-key="' + escapeHtml(group.key) + '">';
        html += '<a class="wwc-rel-link" href="' + escapeHtml(url) + '" title="' + escapeHtml(label) + '">';
        html += '<div class="wwc-rel-img-wrapper">';

        if (BADGE_TEXT[group.key]) {
          html += '<span class="wwc-rel-card-badge">' + escapeHtml(BADGE_TEXT[group.key]) + '</span>';
        }

        html += '<img loading="' + lazyValue + '" decoding="async" fetchpriority="' + (index === 0 ? 'high' : 'auto') + '" width="320" height="320" sizes="(max-width:750px) 120px, 200px" alt="' + escapeHtml(label) + '" src="' + escapeHtml(imageSrc) + '">';
        html += '</div></a>';
        html += '<a class="wwc-rel-title-link" href="' + escapeHtml(url) + '">';
        html += '<p class="wwc-rel-title">' + escapeHtml(label) + '</p>';
        html += '</a>';
        html += '<div class="wwc-rel-info">';

        if (materialCount > 1) {
          html += '<span class="wwc-rel-badge wwc-rel-badge--materials">' + materialCount + ' ' + escapeHtml(LABEL_MATERIALS);
          html += '<div class="wwc-rel-tip">';

          materials.forEach(function (materialLabel) {
            html += renderSwatch(materialLabel, materialMap[materialLabel]);
          });

          html += '</div></span>';
        } else if (materialCount === 1) {
          const only = materials[0];
          const onlyDisplay = MATERIAL_DISPLAY[only] || only;

          html += '<a class="wwc-rel-badge" href="' + escapeHtml(materialMap[only]) + '" aria-label="' + escapeHtml(LABEL_MATERIALS + ' ' + onlyDisplay) + '">' + escapeHtml(onlyDisplay) + '</a>';
        }

        sizes.forEach(function (size) {
          html += '<span class="wwc-rel-badge">' + escapeHtml(size) + '</span>';
        });

        const infoText = String(INFO_TEXT[group.key] || '').trim();

        if (showInfo && infoText) {
          html += '<span class="wwc-rel-badge" data-tip="' + escapeHtml(infoText) + '">i</span>';
        }

        if (extra) {
          html += '<a class="wwc-rel-badge" href="' + escapeHtml(url) + '">' + escapeHtml(extra) + '</a>';
        }

        html += '</div>';

        if (showSwatches && materialCount) {
          html += '<div class="wwc-rel-swatches" aria-label="' + escapeHtml(LABEL_MATERIALS) + '">';

          materials.forEach(function (materialLabel) {
            html += renderSwatch(materialLabel, materialMap[materialLabel]);
          });

          html += '</div>';
        }

        html += '</div>';
      });

      wrap.innerHTML = html;
      wrap.style.visibility = 'visible';
      sliderEl.setAttribute('aria-busy', 'false');

      if (swiper) {
        swiper.update();
        wireTooltips();
        wireActive();
        return;
      }

      if (window.Swiper) {
        swiper = new window.Swiper(sliderEl, {
          slidesPerView: 'auto',
          spaceBetween: cfg.gap || 20,
          initialSlide: initialSlideIndex,
          navigation: {
            nextEl: root.querySelector('.bubble-next'),
            prevEl: root.querySelector('.bubble-prev')
          },
          scrollbar: {
            el: root.querySelector('.wwc-rel-scrollbar'),
            draggable: true
          }
        });

        wireTooltips();
        wireActive();
        return;
      }

      setTimeout(function () {
        enhance(groups);
      }, 80);
    }

    const cacheKey = 'wwc_city_bubbles_' + product.id + '_' + cityTag;
    const cacheTTL = 36e5;

    function getCache() {
      if (cfg.designMode) return null;

      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey));

        if (cached && Date.now() - cached.t < cacheTTL) {
          return cached.d;
        }
      } catch (error) {
        return null;
      }

      return null;
    }

    function setCache(data) {
      if (cfg.designMode) return;

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: data }));
      } catch (error) {
        // Silent fail.
      }
    }

    function renderForActive() {
      if (!buckets) return;

      const groups = buildGroupsForMaterial(activeMaterial);

      if (!groups || groups.length === 0) {
        root.style.display = 'none';
        return;
      }

      root.style.display = '';
      enhance(groups);
    }

    function start() {
      const cached = getCache();

      if (cached) {
        rawProducts = cached;
        buckets = buildBuckets(rawProducts);
        renderForActive();
        return;
      }

      const productsJsonUrl = makeLocalizedUrl('collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250');

      fetch(productsJsonUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Network error');
          return response.json();
        })
        .then(function (json) {
          rawProducts = json.products || [];
          setCache(rawProducts);
          buckets = buildBuckets(rawProducts);
          renderForActive();
        })
        .catch(function () {
          sliderEl.setAttribute('aria-busy', 'false');
        });
    }

    if (cfg.showTabs) {
      const tabs = root.querySelectorAll('.wwc-tab');

      tabs.forEach(function (button) {
        if (button.dataset.mat === activeMaterial) {
          button.setAttribute('aria-selected', 'true');
        }

        button.addEventListener('click', function () {
          tabs.forEach(function (tab) {
            tab.setAttribute('aria-selected', 'false');
          });

          button.setAttribute('aria-selected', 'true');
          activeMaterial = button.dataset.mat;

          if (rawProducts && buckets) {
            renderForActive();
          } else {
            start();
          }
        });
      });
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          start();
        }
      }, { rootMargin: '200px' });

      observer.observe(root);
    } else {
      start();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', start);
      document.addEventListener('shopify:section:select', start);
    }
  });
})();